/**
 * SkeletonPostCard Component
 * Static skeleton loader (no shimmer animation)
 * Layout matches PostCard exactly
 */

const SkeletonPostCard = () => {
  return (
    <div
      className="rounded-xl overflow-hidden"
      style={{ background: '#0A0A0A', border: '1px solid #1E1E1E' }}
    >
      {/* Header */}
      <div className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Avatar */}
          <div 
            className="w-10 h-10 rounded-full" 
            style={{ background: '#1E1E1E' }}
          />
          <div>
            {/* Author name */}
            <div 
              className="h-4 w-32 rounded mb-2" 
              style={{ background: '#1E1E1E' }}
            />
            {/* Date */}
            <div 
              className="h-3 w-20 rounded" 
              style={{ background: '#1E1E1E' }}
            />
          </div>
        </div>
        {/* Badge placeholder */}
        <div 
          className="h-6 w-16 rounded-full" 
          style={{ background: '#1E1E1E' }}
        />
      </div>

      {/* Image */}
      <div 
        className="w-full aspect-video" 
        style={{ background: '#1E1E1E' }}
      />

      {/* Text content */}
      <div className="p-4 space-y-2">
        <div 
          className="h-4 w-full rounded" 
          style={{ background: '#1E1E1E' }}
        />
        <div 
          className="h-4 w-4/5 rounded" 
          style={{ background: '#1E1E1E' }}
        />
        <div 
          className="h-4 w-3/5 rounded" 
          style={{ background: '#1E1E1E' }}
        />
      </div>

      {/* Action Buttons */}
      <div className="px-4 pb-4 space-y-3">
        <div className="flex gap-2">
          <div 
            className="h-12 flex-1 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
          <div 
            className="h-12 flex-1 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
        </div>
      </div>

      {/* Interaction Bar */}
      <div className="px-4 pb-4 flex items-center justify-between border-t" style={{ borderColor: '#1E1E1E' }}>
        <div className="flex items-center gap-2 py-3">
          {/* Vote buttons */}
          <div 
            className="h-9 w-20 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
          <div 
            className="h-9 w-20 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
        </div>
        <div className="flex items-center gap-2">
          {/* Save/Share buttons */}
          <div 
            className="h-9 w-9 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
          <div 
            className="h-9 w-9 rounded-lg" 
            style={{ background: '#1E1E1E' }}
          />
        </div>
      </div>
    </div>
  );
};

export default SkeletonPostCard;
